import {
    GetUserConsentResponseDto,
    CreateUserConsentRequestDto,
    getUserConsentResponseSchema,
} from "@/api-schema/user-consent-schema";
import { api } from "@/store/api";

const ENDPOINT_PREFIX = "contentUseStatementAcceptance";

const USER_CONSENT_CACHE_TYPE = "UserConsent";

export const userConsentApi = api.enhanceEndpoints({ addTagTypes: [USER_CONSENT_CACHE_TYPE] }).injectEndpoints({
    endpoints: (builder) => ({
        getUserConsent: builder.query<GetUserConsentResponseDto, void>({
            query: () => {
                return {
                    url: `${ENDPOINT_PREFIX}/lastAccepted`,
                    method: "GET",
                };
            },
            transformResponse: (response): GetUserConsentResponseDto => {
                const { data, error } = getUserConsentResponseSchema.safeParse(response);
                if (error) {
                    console.error(error);
                    throw new Error("Failed to parse get user consent response");
                }
                return data;
            },
            providesTags: [{ type: USER_CONSENT_CACHE_TYPE }],
        }),

        createUserConsent: builder.mutation<void, CreateUserConsentRequestDto>({
            query: (body) => {
                return {
                    url: ENDPOINT_PREFIX,
                    method: "POST",
                    body,
                };
            },
            invalidatesTags: [{ type: USER_CONSENT_CACHE_TYPE }],
        }),
    }),
});

export const { useGetUserConsentQuery, useCreateUserConsentMutation } = userConsentApi;
